import { HTTP } from './http-common';
import { UTILS } from './http-common';
import { privateServiceURL } from '@Base/plugins/axios.js';

export default {
  getCertificado(token, url, cbok, cberr) {
    HTTP.get(privateServiceURL + `${url}`, {
      responseType: 'blob',
      headers: {
        'X-SOLICITUD': token,
      },
    })
      .then((response) => {
        cbok(response.data);

        UTILS.downloadDocument(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getNotificacion(token, id, cbok, cberr) {
    HTTP.get(privateServiceURL + 'notificacion/estado/' + id, {
      headers: {
        'X-SOLICITUD': token,
      },
    })
      .then((response) => {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  requestSignCode(token, signCode, cbok, cberr) {
    HTTP.post(privateServiceURL + 'notificacion/requestSignCode', signCode, {
      headers: {
        'X-SOLICITUD': token,
      },
    })
      .then((response) => {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  signNotification(token, signCode, cbok, cberr) {
    HTTP.post(privateServiceURL + 'notificacion/signNotification', signCode, {
      headers: {
        'X-SOLICITUD': token,
      },
    })
      .then((response) => {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  getDocumento(token, id, cbok, cberr) {
    HTTP.get(privateServiceURL + 'notificacion/getDocumento/' + id, {
      responseType: 'blob',
      headers: {
        'X-SOLICITUD': token,
      },
    })
      .then((response) => {
        cbok(response.data);

        UTILS.downloadDocument(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
};
